const items = [
  "Full-Spectrum Doula Care",
  "Childbirth Education",
  "Health Coaching",
  "San Joaquin County",
  "Postpartum Wellness",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-heading font-extrabold uppercase tracking-[0.15em] text-lg sm:text-xl text-[#F6F2FF] px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 bg-[#F5B301] shrink-0" />
      </span>
    ))}
  </div>
);

const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative bg-[#2E1B4D] py-6 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default EditorialMarquee;
